import { SectionTitleCard } from '../../components/cards/page-title-card';
import { ServiceCard } from '../../components/cards/service-card';
import { FilterCategories } from '../../components/filter-categories/filter-categories';
import { SERVICE_LIST_QUERY_KEY, useFetch } from '../../hooks/useFetch';
import { getImageUrl } from '../../helpers/img-resolve';
import { useEffect, useState } from 'react';
import { ServiceCardSkeleton } from '../../components/skeletons/service-card.skeleton';
import { useSearchParams } from 'react-router-dom';

export const ServiceListPage = () => {
  const { data: serviceListApi, isLoading: isLoadingService } = useFetch('repair-service',{ queryKey: SERVICE_LIST_QUERY_KEY})
  const { data: serviceCategoryListApi, isLoading: isLoadingCategory} = useFetch('repair-service/category/list')


  const [searchParams] = useSearchParams();
  const query = searchParams.get('query'); // ←


  const filterCategories = (serviceCategoryListApi?.payload ?? []).map(category => ({
    id: category.id,
    name: category.name,
    src: getImageUrl('img',category.iconName),
    checked: false
  }))

  const services = serviceListApi?.payload ?? []
  const [selectedCategories, setSelectedCategories] = useState([]);

  const onCategoriesChange = (updatedCategory) => {
    setSelectedCategories(prevCategories =>
      prevCategories.map(category => {
        if (category.id === updatedCategory.id) {
          return { ...category, checked: !category.checked };
        }
        return category;
      })
    );
  }

  useEffect(() => {
    setSelectedCategories(filterCategories);
  }, [isLoadingCategory,isLoadingService])


  const filteredServices = services.filter(service => {
    const checkedCategories = selectedCategories.filter(cat => cat.checked);
    if (checkedCategories.length === 0) return true;
    return service.categories?.some(serviceCategory =>
      checkedCategories.some(checkedCategory =>
        checkedCategory.id === serviceCategory.id
      )
    );
  });


  const searchServiceList = query ?
    filteredServices.filter((service) => {
      const lowerQuery = query.toLowerCase();
      return (
        service.name.toLowerCase().includes(lowerQuery) ||
        service.categories?.some(category => category.name.toLowerCase().includes(lowerQuery))
      );
    }) : filteredServices;

  // console.log("test", test);


  return (
    <div className={'mb-6'}>
      <SectionTitleCard/>
      <FilterCategories
        filterCategories={selectedCategories}
        onCategoriesChange={onCategoriesChange}
        isLoading={isLoadingCategory}
      />
      <div className={'flex flex-wrap gap-3 mt-5 md:px-0'}>
        {isLoadingService ?
          Array(6).fill().map((_, index) =>
            <ServiceCardSkeleton key={index} />
          )
          :
          searchServiceList.map((item) =>
            <ServiceCard key={item.serviceId || item.id} service={item}/>
          )
        }
      </div>
    </div>
  )
}